import { FC } from 'react'

type CompanyAvatarProps = {
  logoUrl?: string | null
  companyName?: string
  size?: number
}

const CompanyAvatar: FC<CompanyAvatarProps> = ({
  companyName,
  logoUrl,
  size = 44,
}) => {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={companyName}
        className='rounded-circle'
        style={{
          height: size,
          objectFit: 'cover',
          width: size,
        }}
      />
    )
  }

  const initial = companyName?.charAt(0) || ''
  const fontSize = size <= 24 ? size * 0.58 : size * 0.4

  return (
    <div
      className='rounded-circle bg-primary d-flex align-items-center justify-content-center flex-shrink-0'
      style={{ height: size, width: size }}
    >
      <span
        className='text-white fw-semibold'
        style={{ fontSize, lineHeight: 1 }}
      >
        {initial}
      </span>
    </div>
  )
}

export default CompanyAvatar
